<div class="flex max-h-screen h-screen w-full">
  <sidebar-menu/>
  <div class="max-h-screen w-full overflow-y-scroll w-full h-full">
    <div class="flex-grow-1 p-4 h-full w-full">
      <router-outlet class="h-full"/>
    </div>
  </div>
</div>
